import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "exclamation-mark-circle-11", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 11 11", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { fill: "none", fillRule: "evenodd" },
        React.createElement("circle", { cx: 5.5, cy: 5.5, r: 5, stroke: "currentColor" }),
        React.createElement("rect", { width: 1, height: 3.5, x: 5, y: 2.5, fill: "currentColor", rx: 0.5 }),
        React.createElement("rect", { width: 1, height: 1, x: 5, y: 7, fill: "currentColor", rx: 0.5 })));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
